<template>
  <div id="team-list">

    <create-sidebar :isSidebarActive="addNewDataSidebar" :model="addModel" @closeSidebar="initAddSideBar" />

    <div class="mb-4 flex justify-between">
      <vs-button type="relief" icon-pack="feather" icon="icon-plus" @click="addNewDataSidebar = true">创建新的团队</vs-button>
      <vs-button v-if="goBack" type="border" icon-pack="feather" icon="icon-arrow-right" icon-after @click="goToSignUp">继续填写报名表</vs-button>
    </div>
    <div class="items-grid-view vx-row match-height" v-if="teamList.length" appear>
        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in teamList" :key="item.objectID" :title="item.title">
            <item-grid-view :item="item">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                    <div class="flex flex-wrap">

                        <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToTeamDetail(item)">
                            <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" />

                            <span class="ml-2">查看团队信息</span>
                        </div>
                        <div
                            class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                            @click="openConfirm(item)">
                            <feather-icon icon="XIcon" svgClasses="h-4 w-4" />

                            <span class="ml-2">解散团队</span>
                        </div>

                        
                    </div>
                </template>
            </item-grid-view>
        </div>
    </div>
    <vs-alert v-else>
      你还没有创建任何团队。
    </vs-alert>


  </div>
</template>

<script>
import { list, disband } from "@/api/team";
import { getToken } from "@/utils/tools";
import CreateSidebar from '@/views/team/components/CreateSidebar' 

const ItemGridView = () => import("./components/ItemGridView.vue");

export default {
  data() {
    return {
      teamList: [],
      addNewDataSidebar: false,
      addModel: true,
      currentTeam: null,
      goBack: false,
    };
  },
  components: {
    ItemGridView,
    CreateSidebar,
  },
  computed: {
    listitems() {
      return this.teamList;
    },
  },
  methods: {
    initAddSideBar(status) {
      this.addNewDataSidebar = false
      this.addModel = true
      this.currentRule = {}
      if (status) {
        this.getList()
      }
    },
    getList() {
      let that = this;
      list({
        access_token: getToken(),
        type: 'create'
      }).then((res) => {
        const data = res.data;
        that.teamList = data.list;
      });
    },
    goToMatchDetail(item) {
      window.open(item.url);
    },
    goToTeamDetail(item) {
      this.$router.push({path: '/team/detail', query: {team: JSON.stringify(item), type: 'create'}});
    },
    openConfirm(team) {
      this.currentTeam = team
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `解散团队`,
        text: '警告！团队解散后无法恢复，之前参赛的数据也无法查看，请确认你的操作！',
        acceptText: '我了解，仍要解散。',
        cancelText: '好吧，我再想想',
        accept: this.acceptAlert
      })
    },
    acceptAlert() {
      let that = this
      disband({
        access_token: getToken(),
        teamId: that.currentTeam.id
      }).then((res) => {
        if (res.data.err_code === 0){
          this.$vs.notify({
            color: 'success',
            title: '操作成功',
            text: '你的团队已经被解散！'
          })
          this.getList();
        }
      });
    },
    goToSignUp() {
      this.$router.push(this.goBack)
    }
  },
  created() {
    if (this.$route.query.ref) {
      this.goBack = this.$route.query.ref
    }
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
#team-list {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}
</style>
